import { HiEye } from "react-icons/hi2";

export const EyeIcon = ({ width, height, color, ...props }) => (
  <HiEye
    size={width || height || 20}
    color={color || "currentColor"}
    {...props}
  />
);
